<template>
  <div>
    <!--  -->
    <div class="infoBox" style="padding: 0;height: auto;">
      <video
        class="videoBox"
        controls
        src="../assets/webImg/rightVideo.mp4"
      ></video>
    </div>
    <!-- Ventajas del préstam -->
    <div class="infoBox" id="first">
      <h3>Ventajas del préstamo MasterSol</h3>
      <ul>
        <li v-for="(item, index) in oneList" :key="index">
          <img src="../assets/images/infoIcon.png" alt="" />
          <p>{{ item }}</p>
        </li>
      </ul>
    </div>
    <!-- REQUISITOS -->
    <div class="infoBox" id="second">
      <h3>REQUISITOS</h3>
      <ul>
        <li v-for="(item, index) in twoList" :key="index">
          <img src="../assets/images/infoIcon.png" alt="" />
          <p>{{ item }}</p>
        </li>
      </ul>
    </div>

    <div class="progress" id="third">
      <h5>Pasos para solicitar</h5>
      <img src="../assets/images/progressImg.png" alt="" />
    </div>

    <!-- contactBox -->
    <div class="contactBoxStyle" id="fourth">
      <h3>Contáctenos</h3>
      <p>Correo electrónico: mastersol.service@gmail.com</p>
      <p>Sitio web: https://www.mastersol.tech/home</p>
      <p>
        Puedes consultar en nuestra página oficial en www.mastersol.tech o
        llamar a su centro de atención telefónica al {{ phoneArr.join(",") }}
      </p>
      <p>Horario de trabajo: 9:00 a 19:00 horas de lunes a viernes</p>
    </div>
    <!-- Información sobre nosotros -->
    <div
      class="contactBoxStyle"
      style="padding: 0.47rem 0.35rem 0.35rem"
      id="last"
    >
      <h3>Información sobre nosotros</h3>
      <p style="margin: 0">
        La mejor plataforma de préstamo en Perú, solicita un préstamo de hasta
        S/ 5,000 en menos de tres minutos. MasterSol es una empresa de servicios
        financieros con licencia en Perú. Es nuestra responsabilidad y
        obligación informar a nuestros usuarios de nuestra política de
        privacidad (https://www.mastersol.tech/h5/privacidad.html). Si tiene
        alguna pregunta, no dude en ponerse en contacto con nosotros. Correo
        electrónico: {{ emailArr.join(",") }}.
      </p>
    </div>
  </div>
</template>

<script>
import { getServerInfo } from "../utils/api/h5page";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      oneList: [
        "Obtienes el préstamo en 3 simples pasos",
        "AUMENTA SIEMPRE TU LINERA DE CRÉDITO",
        "Soporta métodos de pago como BCP, BBVA, SCOTIABANK, INTERBANK y TAMBO etc",
        "MasterSol mantenemos tu información segura mediante el cifrado SSL",
      ],
      twoList: [
        "Ser residente de Perú",
        "Tener más de 18 años",
        "Tener un número de celular",
      ],
      phoneArr: [],
      emailArr: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (!sessionStorage.getItem("phoneArr")) {
      getServerInfo().then(({ data }) => {
        sessionStorage.setItem(
          "phoneArr",
          JSON.stringify(data.data.mobileList)
        );
        sessionStorage.setItem("whatsAppArr", JSON.stringify(data.data.waList));
        sessionStorage.setItem("emailArr", JSON.stringify(data.data.emailList));
        this.phoneArr = data.data.mobileList;
        this.emailArr = data.data.emailList;
      });
    } else {
      this.phoneArr = JSON.parse(sessionStorage.getItem("phoneArr"));
      this.emailArr = JSON.parse(sessionStorage.getItem("emailArr"));
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.infoBox {
  // width: 100%;
  padding: 0.4rem 1rem 0.4rem 0.3rem;
  background: #ffffff;
  border-radius: 0.2rem;
  margin-bottom: 0.3rem;
  overflow: hidden;
  .videoBox {
    width: 100%;
    height: 100%;
    display: block;
  }
  h3 {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.4rem;
  }
  ul {
    li {
      display: flex;
      font-family: Roboto, Roboto;
      font-weight: 400;
      color: #333333;
      margin-bottom: 0.3rem;
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.24rem;
        color: #333333;
        margin-left: 0.1rem;
      }
      img {
        width: 0.3rem;
        height: 0.3rem;
        vertical-align: middle;
      }
    }
  }
}

.progress {
  width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding-top: 0.34rem;
  text-align: center;
  h5 {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.42rem;
  }
  img {
    width: 5.6rem;
  }
}
.contactBoxStyle {
  // width: 100%;
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.47rem 0.39rem 0.35rem;
  margin-top: 0.3rem;
  h3 {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 700;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.3rem;
  }
  p {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.26rem;
    color: #333333;
    margin-bottom: 0.2rem;
  }
}
</style>
